import React from "react";
import { CheckCircle } from "phosphor-react";

export default function PriceCard({
  topText,
  price,
  frequency,
  newPriceText,
  isBestOffer,
  onClick,
}) {
  return (
    <div
      className={`bg-gray-50 w-[250px] md:w-[300px] h-[400px] shadow-xl md:m-6 m-2 rounded-xl p-4 flex flex-col justify-between border-2 ${
        isBestOffer ? "border-tertiary" : ""
      }`}
    >
      <div>
        <p className="text-gray-500 italic text-sm">{topText}</p>
      </div>
      <div>
        <div className="flex items-end mb-1">
          <p className="mr-2 md:text-5xl text-3xl">{price}€</p>
          <p>par {frequency}</p>
        </div>
        <div className="flex items-end mb-6 italic min-h-[18px]">
          {newPriceText ? (
            <p className="mb-0.5 text-xs text-gray-500">{newPriceText}</p>
          ) : (
            <></>
          )}
        </div>
        <div className="flex items-center">
          <div className="text-primary text-xs mr-2">
            <CheckCircle size={20} weight="fill" color="#7fec93" />
          </div>
          <p>Accès intégral à Influx</p>
        </div>
        <div className="flex items-center">
          <div className="text-primary text-xs mr-2">
            <CheckCircle size={20} weight="fill" color="#7fec93" />
          </div>
          <p>Support disponible 7j/7</p>
        </div>
      </div>
      <div className="flex justify-center">
        <div
          className="self-end uppercase w-full text-center h-fit bg-primary rounded-lg px-4 py-1 text-white border-2 font-bold text-md cursor-pointer hover:bg-white hover:text-primary border-primary transition duration-200"
          onClick={onClick}
        >
          S'inscrire
        </div>
      </div>
    </div>
  );
}
